<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <month-picker v-model="month" label="Select Month"></month-picker>
      <v-spacer />

      <div class="d-flex ">
        <v-btn
          @click="printReport"
          class="elevation-0"
          color="primary"
          outlined
          elevation="2"
        >
          <v-icon left> mdi-printer</v-icon>
          Print</v-btn
        >
      </div>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="priorityListingViews"
      :items-per-page="10"
      :loading="loading"
    ></v-data-table>
  </v-card>
</template>

<script>
import { axios, Strings } from '../../../utils'
import MonthPicker from '../../../components/MonthPicker'
export default {
  components: {
    MonthPicker
  },
  data() {
    return {
      loading: false,

      headers: [
        {
          text: 'Business Name',
          align: 'start',
          sortable: true,
          value: '0'
        },
        {
          text: 'Email',
          align: 'start',
          sortable: true,
          value: '1'
        },
        {
          text: 'Website',
          align: 'start',
          sortable: true,
          value: '2'
        },
        {
          text: 'Telephone',
          align: 'start',
          sortable: true,
          value: '3'
        },

        {
          text: 'Mobile',
          align: 'start',
          sortable: true,
          value: '4'
        },
        {
          text: 'Category',
          align: 'start',
          sortable: true,
          value: '5'
        },
        {
          text: 'Suburb',
          align: 'start',
          sortable: true,
          value: '6'
        },
        {
          text: 'plan',
          align: 'start',
          sortable: true,
          value: '7'
        },
        {
          text: 'Messages Sent',
          align: 'start',
          sortable: true,
          value: '8'
        }
      ],
      priorityListingViews: [],
      month: ''
    }
  },
  mounted() {
    this.getPriorityListingViews()
  },
  methods: {
    getPriorityListingViews() {
      this.loading = true
      axios
        .get(
          `/api/new-priority-listing-views?month=${
            this.month ? this.month : new Date().toISOString().substr(0, 7)
          }`
        )
        .then(res => {
          this.priorityListingViews = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=priority&name=XREF HITS REPORT`,
        '_blank'
      )
    }
  },
  watch: {
    month: function() {
      this.getPriorityListingViews()
    }
  }
}
</script>

<style lang="scss" scoped></style>
